import React from "react";
import { Button, Col, Row } from "antd";
import styled from "styled-components";

// Mobiele modal-stijl, gelijk aan het orderpicken (ProductDetailModal / orderpicking-detail).

export const MobileModalTitle = styled.h1`
  margin: 0 0 12px;
  font-size: 22px;
`;

export const MobileSectionLabel = styled.div`
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: #666;
  text-align: center;
  margin-bottom: 12px;
`;

/** Twee even brede, grote knoppen naast elkaar (zoals Exit / Finish bij het orderpicken). */
export const MobileModalFooter = ({ secondary, primary }) => (
  <Row gutter={8}>
    <Col span={12}>
      <Button block size="large" {...secondary.props}>
        {secondary.label}
      </Button>
    </Col>
    <Col span={12}>
      <Button block size="large" type="primary" {...primary.props}>
        {primary.label}
      </Button>
    </Col>
  </Row>
);
